"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMobileCommunicatorWithoutSession = exports.initMobileCommunicator = exports.getMobileConnector = exports.mobileCommunicator = exports.mobileConnector = void 0;
const features_1 = require("../features");
const getMobileConnector = () => exports.mobileConnector;
exports.getMobileConnector = getMobileConnector;
const initMobileCommunicator = async (session, mobileConnectorConfig) => {
    try {
        exports.mobileConnector = await (0, features_1.initMobileConnector)(session, mobileConnectorConfig);
        exports.mobileCommunicator = exports.mobileConnector.getMobileCommunicator();
        await exports.mobileCommunicator.init();
    }
    catch (e) {
        return false;
    }
    return exports.mobileConnector !== null;
};
exports.initMobileCommunicator = initMobileCommunicator;
const initMobileCommunicatorWithoutSession = async () => {
    try {
        exports.mobileConnector = await (0, features_1.initMobileConnectorWithoutSession)();
        exports.mobileCommunicator = exports.mobileConnector?.getMobileCommunicator();
        await exports.mobileCommunicator.init();
    }
    catch (e) {
        return false;
    }
    return exports.mobileConnector !== null;
};
exports.initMobileCommunicatorWithoutSession = initMobileCommunicatorWithoutSession;
//# sourceMappingURL=init.js.map